export default ".choose_document_list {\n  max-height: 40vh;\n  overflow-y: auto;\n}"